import { useCallback, useState } from "react";

import { api_without_cancellation } from "../../../../api/api";

const useUploadESignatureTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadTemplate = useCallback(async ({ caseTypeIds, file }) => {
    setLoading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append("case_type_id", JSON.stringify(caseTypeIds));
      formData.append("file", file);

      const { data } = await api_without_cancellation.post("/sign/templates/upload/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return data;
    } catch (requestError) {
      setError(requestError);
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return { uploadTemplate, loading, error, clearError };
};

export default useUploadESignatureTemplate;
